// Single source of truth for the product name, used by the app-shell and
// standalone (auth / public) wordmarks instead of hardcoding it per page.
export const BRAND_NAME = 'Kego Fûté'
